module.exports = __webpack_public_path__ + "static/media/0_400.142401b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/head/0_400.png
// module id = 158
// module chunks = 0